// src/awsConfig.ts
import AWS from 'aws-sdk';

const region = 'us-east-1'
// const accessKeyId = process.env.AWS_ACCESS_KEY_ID || ''
// const secretAccessKey = process.env.AWS_SECRET_ACCESS_KEY || ''
// const sessionToken = process.env.AWS_SESSION_TOKEN || ''
const UserPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID || ''
const ClientId = process.env.REACT_APP_COGNITO_CLIENT_ID || ''
// Identity Pool vends temporary IAM credentials to the browser so it can sign
// its MQTT-over-WebSocket connection to AWS IoT Core (see services/realtime.ts).
const IdentityPoolId = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || ''

const awsConfig = {
  region
};

AWS.config.update(awsConfig);

export const awsExports = {
  Auth: {
    Cognito: {
      region,
      userPoolId: UserPoolId,
      userPoolClientId: ClientId,
      identityPoolId: IdentityPoolId,
      mandatorySignIn: true
    }
  },
}
export default AWS;
